<template>
	<div class="con">
		<div class="head">
			<div class="head-left">
				<img src="../assets/doctor.png" v-if="docUser.HEAD_PORTRAIT_URL == '' || docUser.HEAD_PORTRAIT_URL == undefined" />
				<img :src="docUser.HEAD_PORTRAIT_URL" alt="" v-else />
				<div class="userDetalis">
					<div class="username">{{docUser.YGXM}}</div>
					<div class="user-disp">
						<div class="usertype">{{docUser.YGJB}}</div>
					</div>
				</div>
			</div>
			<div class="head-right">
				<div class="xingxing" @click="onCollection">
					<img :src="xing == false ? xingshow : xinghide " />
					<div class="code-text" v-if="xing == false">收藏医生</div>
					<div class="code-text-active" v-else>已收藏</div>
				</div>
				<div @click="Consulting">
					<van-icon name="chat-o" size="30" />
					<div class="code-text">咨询</div>
				</div>
			</div>
		</div>
		<div class="list">
			<div class="introduce">信息</div>
			<div class="nav-right-title">
				擅长
			</div>
			<div class="nav-right-text" v-if="docUser.BE_GOOD_AT">
				{{docUser.BE_GOOD_AT}}
			</div>
			<div class="nav-right-text" v-else>
				暂无相关信息
			</div>
			<div class="nav-right-title">
				介绍
			</div>

			<div class="nav-right-text" v-if="docUser.REMARK">
				{{docUser.REMARK}}
			</div>
			<div class="nav-right-text" v-else>
				暂无相关信息
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'communicationDeta',
		data() {
			return {
				msg: '通讯录详情',
				docUser: {},
				xing: false,
				xingshow: require('../assets/stars-1.png'),
				xinghide: require('../assets/stars.png'),
				cardUserInfo: {},
			}
		},
		methods: {
			//收藏医生
			onCollection() {
				if (this.cardUserInfo == '') {
					this.$dialog.confirm({
						title: '登录',
						message: '是否去绑定个人信息？'
					}).then(() => {
						this.$router.push('/patient')
					}).catch(() => {});
					return false;
				}
				this.$store.commit('Load', true)
				this.$Axios.Post('/collect/collectDoctor?ygdm=' + this.docUser.YGDM + '&brid=' + this.cardUserInfo.brid + '&ksdm=' +
					this.docUser.KSDM + '&mzks=' + this.docUser.MZKS + '&bahm=' + this.cardUserInfo.bahm, null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if (res.data.code == 0) {
						if (res.data.COLLECT_STATE == 1) {
							this.$toast.success('收藏成功')
							this.xing = !this.xing;
						} else {
							this.$toast.success('取消成功')
							this.xing = !this.xing;
						}
					} else {
						this.$toast.success('请检查网络')
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//咨询聊天
			Consulting() {
				this.$router.push({
					path: '/chatRoom',
					query: {
						doctor: JSON.stringify(this.docUser)
					}
				})
			},
			//查询是否收藏
			GetCollectState() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/collect/getCollectState?ygdm=' + this.docUser.YGDM + '&brid=' + this.cardUserInfo.brid + '&bahm=' + this.cardUserInfo.bahm, null).then(
					res => {
						console.log(res)
						this.$store.commit('Load', false)
						if (res.code == 0) {
							if (res.COLLECT_STATE == 1) {
								this.xing = true;
							} else {
								this.xing = false;
							}
						}
					}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			}
		},
		mounted() {
			console.log(this.$route.query.list)
			this.docUser = JSON.parse(this.$route.query.list);
			let cardUserInfo = localStorage.getItem('cardUserInfo');
			console.log(JSON.parse(cardUserInfo))
			if (cardUserInfo != '') { //如果不是游客的话
				this.cardUserInfo = JSON.parse(localStorage.getItem('cardUserInfo'));
			} else {
				this.cardUserInfo = '';
			}
			this.GetCollectState();
		},
		created() {},
	}
</script>

<style scoped>
	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
		background-color: #fff;
	}

	.head-left {
		display: flex;
		align-items: center;
	}

	.head-left img {
		margin-right: 10px;
		width: 60px;
		height: 60px;
	}

	.username {
		color: #000000;
		font-size: 15px;
	}

	.usertype {
		margin: 0 5px;
		color: #666;
	}

	.user-disp {
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: space-around;
		font-size: 13px;
	}

	.head-right {
		display: flex;
		text-align: center;
	}

	.xingxing {
		margin-right: 20px;
	}

	.head-right img,
	.xingxing img {
		width: 30px;
		height: 30px;
	}

	.code-text {
		margin-top: 10px;
		font-size: 13px;
	}

	.code-text-active {
		margin-top: 10px;
		color: #F4EA2A;
	}

	.list {
		padding: 10px;
		margin-top: 10px;
		background-color: #fff;
	}

	.introduce {
		padding: 10px 0;
		font-size: 16px;
		font-weight: 700;
		color: #000;
		background-color: #fff;
	}

	.nav-right-text {
		margin: 10px 0;
		font-size: 14px;
		color: #999;
		text-indent: 2em;
	}

	.nav-text {
		padding: 10px;
		color: #27bec4;
		border-bottom: 2px solid #27BEC4;
	}
</style>
